import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { GlobalService } from '../services/global.service';
import { AccessService } from '../services/access.service';

export const adminGuard: CanActivateFn = async (_route, state) => {
  const authService = inject(AuthService);
  const globalService = inject(GlobalService);
  const accessService = inject(AccessService);
  const router = inject(Router);
  let user = globalService.loggedUserClass;

  if (!authService.isLoggedin(user)) {
    const restoredUser = authService.restoreSession();
    if (restoredUser) {
      globalService.loggedUserClass = restoredUser;
      user = restoredUser;
    } else {
      router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }

  if (user?.Admin || user?.SiteManagement || user?.NavigateTo === '/crm' || user?.NavigateTo === '/telemedicina') {
    return true;
  }

  try {
    const [hasTelemedAccess, hasCrmAccess] = await Promise.all([
      accessService
        .GetUsersAccessValidate('Telemedicina & Rede Médica', 'Aceder à Plataforma de Telemedicina')
        .catch(() => false),
      accessService.GetUsersAccessValidate('CRM', 'Aceder ao CRM').catch(() => false),
    ]);
    if (hasTelemedAccess || hasCrmAccess) {
      return true;
    }
  } catch (_) {}

  router.navigate(['/home']);
  return false;
};
